module.exports = __webpack_public_path__ + "media/images/unsplash_img_02-p-800-31bb939fb16dbb7e65b0a8edac162334.jpeg";